import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="announcement-online-switch" (on the switch form)
// Asks for a confirmation before the switch puts an announcement online; cancelling leaves it off.
export default class extends Controller {
  static values = { message: String }

  connect() {
    // Capture phase: runs before the checkbox's inline onclick that submits the form.
    this.onClick = this.confirm.bind(this)
    this.element.addEventListener("click", this.onClick, true)
  }

  disconnect() {
    this.element.removeEventListener("click", this.onClick, true)
  }

  confirm(event) {
    if (event.target.type !== "checkbox" || !event.target.checked) return
    if (window.confirm(this.messageValue)) return

    event.preventDefault()
    event.stopPropagation()
  }
}
